import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Heading, Stack } from '@99designs/ui';

interface LayoutProps {
    title: string;
    description?: string;
    children: React.ReactNode;
    heading?: string;
}

export function Layout({ title, description, children, heading }: LayoutProps) {
    return (
        <>
            <Helmet title={title}>
                <meta name="description" content={description} />
            </Helmet>
            <Stack space="gutter">
                <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="baseline"
                    justifyContent="stretch"
                >
                    {heading && (
                        <Heading appearanceLevel={1} accessibilityLevel={1} withDivider>
                            {heading}
                        </Heading>
                    )}
                </Box>
                {children}
            </Stack>
        </>
    );
}
